// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"0effab83","417":"f0f609ae","787":"070eb321","871":"08c4323a"}[chunkId] + ".chunk.js";
};